export const GetQuizzesAsManagerRequestedModelFields = [
  "id",
  "name",
  "description",
  "image",
  "color",
  "group",
  "question_count",
  "max_score",
  "created_at",
];

export const ManagerQuizRequestedModelFields = [
  "id",
  "owner_id",
  "name",
  "description",
  "settings",
  "additional",
  "components",
  "component_settings",
];